<ul>
  <li
    *ngFor="let tab of tabs"
    routerLinkActive="active"
    [class.active]="tab.activeTabName == tab.title"
    [routerLink]="tab.url"
    [class.pe]="tab.url === 'pe'"
    (click)="clickedTab.emit(tab.title)"
  >
    <a>{{ tab.title }}</a>
  </li>
</ul>
<router-outlet></router-outlet>
